module.exports = __webpack_public_path__ + "static/img/circel_02_m.601f76b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/circel_02_m.png
// module id = vjQw
// module chunks = 1